import React, { createContext, useContext } from 'react';
import { SharePointService } from '../services/sharePointService';

interface SharePointContextType {
  sharePointService: SharePointService;
}

const SharePointContext = createContext<SharePointContextType | undefined>(undefined);

export const useSharePoint = () => {
  const context = useContext(SharePointContext);
  if (context === undefined) {
    throw new Error('useSharePoint must be used within a SharePointProvider');
  }
  return context;
};

interface SharePointProviderProps {
  children: React.ReactNode;
  sharePointService: SharePointService;
}

export const SharePointProvider: React.FC<SharePointProviderProps> = ({ children, sharePointService }) => {
  const value: SharePointContextType = {
    sharePointService,
  };

  return (
    <SharePointContext.Provider value={value}>
      {children}
    </SharePointContext.Provider>
  );
}; 